import {createSlice} from "@reduxjs/toolkit";
import {ClubFinderLocationResultTypes} from "../../types/ApiTypeDefinition/clubFinderLocationSearchResultTypes";
import {Config} from "../../constants/Config";

interface InitialStateType {
  selectedLocation: ClubFinderLocationResultTypes | null
  isSearchable: boolean
  selectedFormat: any
  isMobileSearchVisible: boolean
  selectedGenderFilter: {
    type: string,
    name: string
  }
  selectedFormatFilterName: any | null;
  activeSearchFilterMobile: {
    locationFilter: boolean
    formatFilter: boolean
    genderFilter: boolean
  },
  searchOptionsLoaded: boolean
  searchButtonPressed: boolean
  isFilterButtonVisible: boolean
  isFilterDrawerVisible: boolean
  isOrgDetailDrawerVisible: boolean
  selectedInclusionFilters: {
    inclusionDisplayValue: string,
    inclusionPlayHQValue: string
  }[] | null;
  selectedDayFilters: any | null;
  selectedMultiGenderFilters: {
    type: string,
    name: string
  }[] | null;
  userLocationAddress: {
    route?: string,
    suburb?: string,
    state?: string
  } | null;
  isUserLocationSearching: string | null;
  applyClickedCounter: number
}

const initialState: InitialStateType = {
  selectedLocation: null,
  isSearchable: false,
  selectedFormat: null,
  isMobileSearchVisible: false,
  selectedFormatFilterName: null,
  selectedGenderFilter: Config.defaultGenderOption,
  activeSearchFilterMobile: {
    locationFilter: false,
    formatFilter: false,
    genderFilter: false
  },
  searchOptionsLoaded: false,
  searchButtonPressed: false,
  isFilterButtonVisible: false,
  isFilterDrawerVisible: false,
  isOrgDetailDrawerVisible: false,
  selectedInclusionFilters: null,
  selectedDayFilters: null,
  selectedMultiGenderFilters: null,
  userLocationAddress: null,
  isUserLocationSearching: null,
  applyClickedCounter: 0
}

const clubFinderSearchBarSlice = createSlice({
  name: 'clubFinderSearchBarSlice',
  initialState,
  reducers: {
    setSelectedLocation(state, actions) {
      state.selectedLocation = actions.payload;
      state.isSearchable = !!actions.payload;
    },
    setSavedFormatFilter(state, action) {
      state.selectedFormat = action.payload.selectedFormatObject;
      state.selectedFormatFilterName = action.payload.selectedFormatTitles;
    },
    setSavedGenderFilter(state, action) {
      state.selectedGenderFilter = action.payload;
    },
    toggleMobileSearch(state, action) {
      state.isMobileSearchVisible = action.payload;
      if(action.payload === true) {
        state.searchButtonPressed = false;
      }
    },
    activeSearchFilterMobile(state, action) {
      if(action.payload.hasOwnProperty('location')) {
        state.activeSearchFilterMobile.locationFilter = action.payload.location;
      }
      if(action.payload.hasOwnProperty('format')) {
        state.activeSearchFilterMobile.formatFilter = action.payload.format;
      }
      if(action.payload.hasOwnProperty('gender')) {
        state.activeSearchFilterMobile.genderFilter = action.payload.gender;
      }
    },
    setIsSearchable(state, actions) {
      state.isSearchable = actions.payload;
    },
    searchOptionsLoaded(state, action) {
      state.searchOptionsLoaded = action.payload;
    },
    searchButtonPressed(state,action) {
      state.searchButtonPressed = action.payload;
    },
    setFilterButtonVisible(state,action) {
      state.isFilterButtonVisible = action.payload;
    },
    toggleFilterDrawerVisibility(state,action) {
      state.isFilterDrawerVisible = action.payload;
    },
    toggleOrgDetailsDrawerVisibility(state,action) {
      state.isOrgDetailDrawerVisible = action.payload;
    },
    setSavedInclusionFilter(state,action) {
      state.selectedInclusionFilters = action.payload;
    },
    setSavedDayFilter(state,action) {
      state.selectedDayFilters = action.payload;
    },
    setUserLocationAddress(state, action) {
      state.userLocationAddress = action.payload;
    },
    setUserLocationSearchingState(state, action) {
      state.isUserLocationSearching = action.payload;
    },
    setSavedMultiGenderFilter(state,action) {
      state.selectedMultiGenderFilters = action.payload;
    },
    setApplyClickedCount(state, action) {
      state.applyClickedCounter = action.payload;
    }
  },
})

export const clubFinderSearchBarSliceActions = clubFinderSearchBarSlice.actions

export default clubFinderSearchBarSlice.reducer;
